var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrugs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2813_10222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 16.2982V14.0326C15.9961 13.4069 16.5033 12.8998 17.1289 12.8998H29.9674C30.5931 12.8998 31.1003 13.4069 31.1003 14.0326V29.9675C31.1003 30.5931 30.5931 31.1003 29.9674 31.1003H15.9961M23.5482 15.2031V28.7969M19.6966 18.5638H14.4102V16.2982H19.6966V18.5638ZM15.1654 18.5638V19.6966L13.8951 20.9669C13.2578 21.6042 12.8998 22.4686 12.8998 23.3699V29.9674C12.8998 30.5931 13.4069 31.1002 14.0326 31.1002H20.0742C20.6999 31.1002 21.207 30.5931 21.207 29.9674V23.3699C21.207 22.4686 20.849 21.6042 20.2117 20.9669L18.9414 19.6966V18.5638H15.1654ZM21.207 28.0794H12.8997V24.2279H21.207V28.0794ZM28.8346 16.7136C28.8346 17.5477 28.1584 18.224 27.3242 18.224C26.4901 18.224 25.8138 17.5477 25.8138 16.7136C25.8138 15.8794 26.4901 15.2031 27.3242 15.2031C28.1584 15.2031 28.8346 15.8794 28.8346 16.7136ZM28.8346 22C28.8346 22.8342 28.1584 23.5104 27.3242 23.5104C26.4901 23.5104 25.8138 22.8342 25.8138 22C25.8138 21.1659 26.4901 20.4896 27.3242 20.4896C28.1584 20.4896 28.8346 21.1659 28.8346 22ZM28.8346 27.2865C28.8346 28.1206 28.1584 28.7969 27.3242 28.7969C26.4901 28.7969 25.8138 28.1206 25.8138 27.2865C25.8138 26.4523 26.4901 25.7761 27.3242 25.7761C28.1584 25.7761 28.8346 26.4523 28.8346 27.2865Z",
    stroke: "url(#paint0_linear_2813_10222)",
    strokeWidth: 1.28906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2813_10222",
    x1: 38.352,
    y1: 11.4068,
    x2: 10.4825,
    y2: 31.9179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB073"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2813_10222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugs);
export default __webpack_public_path__ + "static/media/drugs.b8828c31bbc5fef088345ab6fec1f13e.svg";
export { ForwardRef as ReactComponent };